export default __webpack_public_path__ + "static/media/css3-plain.4f50b33a.svg";